import React from 'react'

import Base from '../_Base'

const ArrowLeft = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M19,11 L7.83,11 L7.83,11 L12.7124956,6.11750442 C13.1018612,5.7281388 13.1018612,5.0968524 12.7124956,4.70748678 C12.7116652,4.70665638 12.7108333,4.70582746 12.71,4.705 L12.707098,4.7021184 C12.316175,4.31394844 11.6849363,4.3150637 11.2953874,4.70461259 L4.70710678,11.2928932 C4.31658249,11.6834175 4.31658249,12.3165825 4.70710678,12.7071068 L11.295,19.295 C11.6843607,19.6843607 12.3156393,19.6843607 12.705,19.295 C13.0944628,18.9055372 13.0947454,18.2741804 12.7056314,17.8843691 L7.83,13 L7.83,13 L19,13 C19.5522847,13 20,12.5522847 20,12 C20,11.4477153 19.5522847,11 19,11 Z" />
  </Base>
)

export default ArrowLeft
